import * as React from "react";
import { ApiSuccess } from "ui/Scripts/source/models/common/apiSuccess";
import { Translations } from "ui/Scripts/source/models/translations";
import { IUnitNodePermissions } from "../../../../models/unit/unitNodePermissions";
import { Dialog } from "../../../framework/Dialog/Dialog";
import { Box } from "@mui/material";
import { UnitPermissionSettingsNew } from "../UnitPermissionSettingsNew";

export interface IUnitPermissionDialogProp {
    companyId: string;
    unitNodePermissions: IUnitNodePermissions;
    onSave: (obj: any) => Promise<ApiSuccess>;
    onOk: () => void;
    onCancel: () => void;
}

export class UnitPermissionDialog extends React.Component<IUnitPermissionDialogProp> {
    private permissionsRef = React.createRef<UnitPermissionSettingsNew>();

    handleCancel = async (closeDialog: boolean) => {
        if (!closeDialog) return;
        this.props.onCancel();
    };

    render() {
        const props = this.props;
        return (
            <Dialog
                id="unit-permission-dialog"
                maxWidth="md"
                maxHeight="90%"
                title={Translations.Permissions}
                body={
                    <Box height="100%" display="flex" flexDirection="column">
                        <UnitPermissionSettingsNew
                            ref={this.permissionsRef}
                            companyId={props.companyId}
                            unitNodePermissions={props.unitNodePermissions}
                            cardView={false}
                            onSave={props.onSave}
                            onOk={props.onOk}
                            onCancel={this.handleCancel}
                        />
                    </Box>
                }
                onClose={() => this.handleCancel(true)}/>
        );
    }
}